import { useEffect, useState } from "react";
import Layout2 from "../layouts/Layout2";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import '../App.css';

const CommissionPayment = () => {
    const endpointURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [unit, setUnit] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    
    const handlePaymentInfo = async (e) => {
        e.preventDefault();
        const paymentInfoArray = {
            "name": name,
            "phone": phone
        };
        setIsLoading(true);
        if (!submitted) {
            setSubmitted(true);
            try {
                const response = await fetch(endpointURL + "/api/v1/commission-payment-insert", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    },
                    body: JSON.stringify(paymentInfoArray),
                });
                const resp = await response.json();
                if (response.status == 200) {
                    if (resp.status === true) {
                        Swal.fire({
                            text: "အောင်မြင်ပါသည်",
                            width: 350,
                        });
                    } else {
                        Swal.fire({
                            text: "Something wrong!",
                            width: 350,
                        });
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        width: 350,
                    });
                }
            } catch (error) {
                console.error('register failed: ', error.message);
            }
            setSubmitted(false);
        }
        setIsLoading(false);
    }
    
    const handleCommissionPayment = async (e) => {
        try {
            const response = await fetch(endpointURL + '/api/v1/commission-payment', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
            });
            const result = await response.json();
            if (result.status === true) {
                setName(result.data["kpay_name"]);
                setPhone(result.data["kpay_phone"]);
                setUnit(result.data["unit"]);
            }
        } catch (error) {
            Swal.fire({
                title: error.message,
                width: 450,
            });
        }
    }
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
        handleCommissionPayment();
    }, []);
    
    return (
        <Layout2 pageType={"ငွေလက်ခံအကောင့်"}>
            <Helmet>
                <title>ငွေလက်ခံအကောင့်</title>
            </Helmet>
            <div className="commission-container">
                <div className="commission-header">
                    <p>ကော်မရှင်ထုတ်ရန် Kpay အချက်အလက်ဖြည့်ပါ</p>
                </div>
                
                <div className="commission-balance">
                    <span>မိမိကော်မရှင်</span>
                    <span className="commission-amount">{unit} MMK</span>
                </div>
                
                <form className="commission-form" onSubmit={handlePaymentInfo}>
                    <div className="form-group-custom">
                        <label htmlFor="name" className="form-label-custom">
                            ငွေလက်ခံအကောင့် အမည် <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="name"
                            defaultValue={name}
                            onChange={(e) => setName(e.target.value)}
                            className="form-input-custom"
                            placeholder="အမည်ရိုက်ထည့်ပါ"
                            autoComplete="off"
                        />
                    </div>
                    
                    <div className="form-group-custom">
                        <label htmlFor="phone" className="form-label-custom">
                            ငွေလက်ခံဖုန်းနံပါတ် (09 ထည့်ရန်) <span className="required">*</span>
                        </label>
                        <input
                            type="number"
                            id="phone"
                            defaultValue={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="form-input-custom"
                            autoComplete="off"
                        />
                    </div>
                    
                    <div className="form-group-custom">
                        <button type="submit" className="form-submit-btn" disabled={isLoading}>
                            <i className="lni lni-checkmark-circle"></i>
                            {isLoading ? "Loading..." : "အတည်ပြု"}
                        </button>
                    </div>
                </form>
            </div>
        </Layout2>
    );
}

export default CommissionPayment;